/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';


export default {
    GetAllGroupsForDropDown,
    GetAllFactoriesByGroupID,
    GetFarmerByFactoryIDDropdown,
    GetVCCFactoriesByGroupID,
    GetFarmerDetailsByMultipleFactoryID,
    GetFinancialGRNDetailsByFarmerID
};

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/FarmerwiseAvailability/GetAllGroupsForFarmerAvailabilityScreen', null);
    return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/FarmerwiseAvailability/GetFactoriesByGroupIDForFarmerAvailabilityScreen', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetVCCFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetVCCFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetFarmerByFactoryIDDropdown(factoryID) {
    const response = await CommonGet('/api/Farmer/GetFarmerDetailsByFactoryIDRouteID', 'factoryID=' + parseInt(factoryID) + '&routeID=' + parseInt(0));
    return response.data;
}

async function GetFinancialGRNDetailsByFarmerID(model) {
    const response = await CommonPost('/api/FinancialGRNReport/GetFinancialGRNReportDetails', null, model);
    return response.data;
}

async function GetFarmerDetailsByMultipleFactoryID(model) {
    const response = await CommonPost('/api/Farmer/GetFarmerDetailsBySupplierTypeMultipleFactoryID', null, model);
    return response.data;
}






